/**
 * Where the page's one scroller — the shell's `<main>` — goes to bring an element into view (periods A6b, A6c). A
 * Change link beside a period reveals the Periods card this way rather than with `scrollIntoView`, which scrolls every
 * scrollable ancestor up to the window: whenever anything made the window scrollable too, the reveal scrolled the
 * window away with the header and the rail on it (A6c).
 *
 * `scrollerTop` and `targetTop` are viewport positions (`getBoundingClientRect().top`) and `scrollTop` the scroller's
 * own; the target lands `REVEAL_MARGIN` below the scroller's top edge, never above its start. Smooth, or with no motion
 * when the reader asks for reduced motion.
 */
export const REVEAL_MARGIN = 16;

export function revealScrollTo(at: {
  scrollerTop: number;
  scrollTop: number;
  targetTop: number;
  reducedMotion: boolean;
}): ScrollToOptions {
  const top = Math.max(0, Math.round(at.scrollTop + at.targetTop - at.scrollerTop - REVEAL_MARGIN));
  return { top, behavior: at.reducedMotion ? 'auto' : 'smooth' };
}
